<script lang="ts" setup>
import { useRouter, useRoute } from 'vue-router'
import { DynamicForm } from '../../dynamic-form'
import { getForm } from '../../../core/services/forms'
import { onBeforeMount, ref } from 'vue'
import { useNotificationsStore } from '@/store/notifications'
import { usePayrollChange } from '@/app/core/composable/routes/useChangePayroll'
import { notificationError } from '@/app/core/util/notificationUtils'
import { getCap, createCap, updateCap } from '../../../core/services/caps'
import { DLoading } from 'front-library'
import { useI18n } from 'vue-i18n'
usePayrollChange(() =>
  Boolean(route.params.id) ? back() : window.location.reload()
)

/* router, notifications */
const notifications = useNotificationsStore()
const router = useRouter()
const route = useRoute()
const { t } = useI18n()

/* Datos componente Loading */
const loading = ref(false)
const messageLoading = ref('')

/* Datos */
const customForm = ref<any>({})
let model: any = {}

const onSubmit = async (model: any) => {
  loading.value = true
  let saved = false
  try {
    if (!route.params.id) {
      saved = await createCap(model)
    } else {
      saved = await updateCap(model, `${route.params.id as string}`)
    }
    if (saved) {
      loading.value = false
      notifications.addNotification({
        title: !route.params.id
          ? t('notification.created')
          : t('notification.edited'),
        text: t('caps.notification.action', [
          !route.params.id
            ? t('notification.wasCreated')
            : t('notification.wasEdited')
        ]),
        type: 'success',
        time: 10000
      })
      void router.push({ name: 'ListCaps' })
    }
  } catch (error: any) {
    notificationError(error, 'caps', t, notifications, loading)
  }
}

const getEntity = async () => {
  if (!route.params.id) return
  model = await getCap(route.params.id as string)
  if (model === undefined) {
    notifications.addNotification({
      title: t('notification.notFound'),
      text: t('caps.notification.error'),
      type: 'error',
      time: 10000
    })
    back()
  }
}

/* Volver */
const back = () => {
  void router.push({ name: 'ListCaps' })
}

onBeforeMount(async () => {
  loading.value = true
  try {
    await getEntity()
    customForm.value = await getForm({
      entity: 'caps'
    })
    if (route.params.id !== undefined) messageLoading.value = t('loading.data')
    loading.value = false
  } catch (error: any) {
    if (error.response.status === 400) {
      notifications.addNotification({
        title: t('notification.notFound'),
        text: t('caps.notification.error'),
        type: 'error',
        time: 10000
      })
      back()
    } else {
      notificationError(error, 'caps', t, notifications, loading)
    }
  }
})
</script>
<template>
  <DLoading v-show="loading" :message="messageLoading" />
  <div class="h-full px-5">
    <div class="bg-gray-50 pb-4">
      <div class="leading-4 pt-responsive">
        <p
          class="text-3xl font-semibold text-shadow text-blue-900"
          v-html="
            route.params.id == undefined ? t('caps.create') : t('caps.edit')
          " />
      </div>
    </div>
    <DynamicForm
      v-if="customForm?.tabs"
      :form-schema="customForm"
      :initial-model="model"
      :title-btn-save="
        route.params.id === undefined
          ? t('form.button.save')
          : t('form.button.update')
      "
      @cancel="back"
      @submit="onSubmit" />
  </div>
</template>
